import { format } from "d3-format";
import React, { Component } from "react";
import PropTypes from "prop-types";

import displayValuesFor from "./displayValuesFor";
import GenericChartComponent from "../GenericChartComponent";

import ToolTipText from "./ToolTipText";
import ToolTipTSpanLabel from "./ToolTipTSpanLabel";
import { functor, isDefined } from "../utils";

class EhlerFisherTooltip extends Component {
  constructor(props) {
    super(props);
    this.renderSVG = this.renderSVG.bind(this);
  }
  renderSVG(moreProps) {
    const { onClick, fontFamily, fontSize, displayFormat, className } =
      this.props;
    const { yAccessor, options, appearance, labelFill, textFill } = this.props;
    const { displayValuesFor } = this.props;

    const {
      chartConfig: { width, height },
    } = moreProps;

    const currentItem = displayValuesFor(this.props, moreProps);
    const ehlerFisherValue = currentItem && yAccessor(currentItem);

    const ef = ehlerFisherValue && ehlerFisherValue.ef;
    const trigger = ehlerFisherValue && ehlerFisherValue.trigger;

    const efDisplay = (isDefined(ef) && displayFormat(ef)) || "n/a";
    const triggerDisplay =
      (isDefined(trigger) && displayFormat(trigger)) || "n/a";

    const { origin: originProp } = this.props;
    const origin = functor(originProp);
    const [x, y] = origin(width, height);

    // Get stroke colors
    const efColor = appearance?.strokeEF?.color || "#2196F3";
    const triggerColor = appearance?.strokeTrigger?.color || "#FF0000";

    return (
      <g
        className={className}
        transform={`translate(${x}, ${y})`}
        onClick={onClick}
        data-evo-id="tooltip-ehler-fisher"
      >
        <ToolTipText x={0} y={0} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>Ehler Fisher (</ToolTipTSpanLabel>
          <tspan fill={efColor}>{options.period}</tspan>
          <ToolTipTSpanLabel fill={labelFill}>)</ToolTipTSpanLabel>
        </ToolTipText>
        <ToolTipText x={0} y={15} fontFamily={fontFamily} fontSize={fontSize}>
          <ToolTipTSpanLabel fill={labelFill}>EF: </ToolTipTSpanLabel>
          <tspan fill={efColor}>{efDisplay}</tspan>
          <ToolTipTSpanLabel fill={labelFill}> Trigger: </ToolTipTSpanLabel>
          <tspan fill={triggerColor}>{triggerDisplay}</tspan>
        </ToolTipText>
      </g>
    );
  }
  render() {
    return (
      <GenericChartComponent
        clip={false}
        svgDraw={this.renderSVG}
        drawOn={["mousemove"]}
      />
    );
  }
}

EhlerFisherTooltip.propTypes = {
  className: PropTypes.string,
  displayFormat: PropTypes.func.isRequired,
  origin: PropTypes.oneOfType([PropTypes.array, PropTypes.func]).isRequired,
  displayValuesFor: PropTypes.func,
  yAccessor: PropTypes.func.isRequired,
  appearance: PropTypes.shape({
    strokeEF: PropTypes.shape({
      color: PropTypes.string,
    }),
    strokeTrigger: PropTypes.shape({
      color: PropTypes.string,
    }),
  }),
  options: PropTypes.shape({
    period: PropTypes.number.isRequired,
  }).isRequired,
  labelFill: PropTypes.string,
  textFill: PropTypes.string,
  fontFamily: PropTypes.string,
  fontSize: PropTypes.number,
  onClick: PropTypes.func,
};

EhlerFisherTooltip.defaultProps = {
  className: "react-stockcharts-tooltip react-stockcharts-ehler-fisher-tooltip",
  displayFormat: format(".3f"),
  displayValuesFor: displayValuesFor,
  origin: [0, 10],
  labelFill: "#4682B4",
  textFill: "#000000",
};

export default EhlerFisherTooltip;
